export default "__VITE_ASSET__DaHbJ4Hv__"